module.exports = __webpack_public_path__ + "img/Impact characterisation - Accident.184a37ac.svg";